(function($){
  $(document).ready(function(){

    function filer_pag(e , p){
      
      e.preventDefault();
      let page = 1;
      if(p != undefined){
        page = p;
      }
      
      var data = $('[data-js-form=filter]').serialize();

      var pagenr = '&page=' + page;
      
      data += pagenr;
    
      $.ajax({
        url: ajaxUrl_news,
        
        data: data,
        type: 'post',
        success: function(result){
          $('[data-js-filter=target]').html(result);
        
        },
        error: function(result){
          console.warn(result);
        },
      });
    };
    $(document).on('change', '[data-js-form=filter]', filer_pag );
    $(document).on('submit', '[data-js-form=filter]', filer_pag );
    $(document).on('click','.pagination-link ul li',function(e){
      
      var page = $(this).attr('p');
      filer_pag(e,page);
      var position = $($(this).attr("href")).offset().top;
      position = position - 150;
      $("body, html").animate({scrollTop: position});
    });
    $(document).on('load', '[data-js-form=filter]', filer_pag );
  });
})(jQuery);